<template>
    <div class="container">
        <app-banner role="banner"/>

        <transition mode="out-in" name="fade">
            <div class="transition-root" key="connecting" v-if="connecting">
                <div class="row">
                    <loading-indicator>Forbinder..</loading-indicator>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import {$eBus} from '@/event-bus'
    import GameClientEvent from '@/enum/GameClientEvent'
    import LoadingIndicator from '@/components/loading-indicator/index'
    import {CurrentUrlInfo} from '@/current-url-info'
    import AppConfig from '@/app-config'
    import * as MutationTypes from '@/store/mutation-types'
    import {getSinglePlayerUrl} from '@/utils/UrlUtil'
    import AppBanner from '@/components/app-banner'

    export default {
        components: {
            LoadingIndicator,
            AppBanner
        },
        data() {
            let currentUrlInfo = CurrentUrlInfo.instance()

            let apiHost = AppConfig.apiHost || currentUrlInfo.getCurrentHost();
            let apiPort = AppConfig.apiPort || currentUrlInfo.getCurrentPort();
            let apiSecure = AppConfig.apiSecure || currentUrlInfo.getCurrentScheme() === 'https';

            let colyseusHost = AppConfig.colyseusHost || apiHost;
            let colyseusPort = AppConfig.colyseusPort;
            let colyseusSecure = AppConfig.colyseusSecure || false;

            return {
                connecting: true,
                connected: false,

                apiHost: apiHost,
                apiPort: apiPort,
                apiSecure: apiSecure,

                colyseusHost: colyseusHost,
                colyseusPort: colyseusPort,
                colyseusSecure: colyseusSecure,
            }
        },
        mounted() {
            this.connecting = true
            this.tryConnect();
        },
        methods: {
            tryConnect() {
                if (this.$gameClient) {
                    this.connect();
                } else {
                    console.log('Game client not yet found.. waiting till next tick and trying again!');

                    this.$nextTick(() => {
                        this.tryConnect();
                    })
                }
            },
            connect() {
                this.$apiClient.setBaseUrlFromHostPort(this.apiHost, this.apiPort, this.apiSecure);

                this.$nextTick(() => {
                    this.$router.push(getSinglePlayerUrl('select-theme'))
                    this.connected = true;
                });
            },
        }
    }
</script>
